import { useMemo } from 'react';
import { lt, useLocalizeText } from '@mews/framework';
import { createOption } from '@mews-commander/ui';
import { SettlementExtent } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { SelectField } from '@mews-commander/legacy-form';
import { useLocalizedTimeUnit } from '../../services';
import { RateGroupFormSchemaKeys } from './RateGroupFormSchema';

export const SettlementExtentField = ({ serviceId }: { serviceId: string }) => {
    const localizedTimeUnitsName = useLocalizedTimeUnit(serviceId, { form: 'plural' });

    const localizeText = useLocalizeText();
    const options = useMemo(
        () => [
            createOption({
                label: localizeText({ textKey: TextKey.SettlementExtentAdditionalExpenses }),
                value: SettlementExtent.AdditionalExpenses,
            }),
            createOption({
                label: localizeText({ textKey: TextKey.SettlementExtentProducts }),
                value: SettlementExtent.Products,
            }),
            createOption({
                /**
                 * The time unit hook can return null due to not having exhausitve dependencies
                 * (a service can be null from selectors etc.). However, in reality that can't
                 * happen, as this whole form would not be possible to render at all.
                 */
                label: localizedTimeUnitsName ?? localizeText({ textKey: TextKey.NightPlural }),
                value: SettlementExtent.TimeUnits,
            }),
        ],
        [localizeText, localizedTimeUnitsName]
    );

    return (
        <SelectField
            name={RateGroupFormSchemaKeys.settlementExtent}
            label={lt('SettlementExtent')}
            bottomCaption={lt('SettlementExtentHint')}
            options={options}
            multiselect
            required
        />
    );
};
